<template>
  <div>
    <v-layout justify-center>
      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">{{ $t('confirmUndo.title') }}</v-card-title>

          <v-card-text>
            {{ $t('confirmUndo.message') }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              @click="onKO"
            >
              {{ $t('common.cancel') }}
            </v-btn>

            <v-btn
              dark
              color="red darken-1"
              @click="onOK(newValue)"
            >
              {{ $t('common.continue') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
  export default {
    props: {
      showDialog: {
        type: Boolean,
        required: true
      },
      onKO: {
        type: Function,
        required: true
      },
      onOK: {
        type: Function,
        required: true
      },
      undoNewValue: {
        type: Object,
        required: false,
        default: null
      }
    },
    data () {
      return {
        dialog: this.showDialog,
        newValue: null
      }
    },
    watch: {
      showDialog (v) {
        this.dialog = v
      },
      undoNewValue (v) {
        this.newValue = v
      }
    }
  }
</script>
